import React from 'react';
import { useBackgroundPriceUpdates } from '@/hooks/use-background-price-updates';

/**
 * Component that handles background price updates for the cart
 * This component should be rendered within the CartProvider context
 * but outside of the CartProvider component itself to avoid circular dependencies
 */
const CartBackgroundPriceUpdater: React.FC = () => {
  // Initialize background price updates
  // This runs discreetly in the background, updating prices every 5 minutes
  // without any visual indication to the user
  useBackgroundPriceUpdates({
    intervalMs: 5 * 60 * 1000, // 5 minutes
    enabled: true,
    pauseWhenHidden: true,
  });

  // This component doesn't render anything - it's just for side effects
  return null;
};

export default CartBackgroundPriceUpdater;
